import { CircularProgress, Dialog, DialogActions, DialogContent } from '@mui/material'
import React, { useEffect, useState } from 'react'
import essProjectServices from '../essProjectServices';
import { useAlert } from '../../../../context/AlertContext';

function DPRForm({projectId,targetList,callBack}) {

    const {AppAlert} = useAlert();
    const [saving,setSavingStatus] = useState(false);
    const [dialogStatus,setDialogStatus] = useState(false);
    const [formData,setFormData] = useState([]);

    const [remark,setRemark] = useState("");


    

    useEffect(()=>{
        if(targetList){
            setFormData(targetList);
        }
    },[targetList])

    const handleInputChange = (i,key,value) =>{
        
        console.log(formData[i]["total"]);

        

        if(formData[i]["total"] < value){
            AppAlert("Value must be less then or equal to "+formData[i]["total"],"error")
            return false
        }

        let _formData = [...formData];
        _formData[i][key] = value;
        setFormData(_formData);
        
    }

    const handleSubmit = () =>{

        const invalidField = formData.find(field => field.completed === "" || field.completed < 0);

        if (invalidField) {
            // Assuming target.title refers to the title property of the field
            AppAlert(`${invalidField.title} cannot be blank or negative number`, "error");
            return false; 
        }

        let payload = {
            projectId:projectId,
            targetList:formData.map(field => { 
                return {targetId:field.id,completed:field.completed }
            }),
            remark:remark
        }
        console.log(payload);
        setSavingStatus(true);
        essProjectServices.updateDPR(payload).then(res=>{
            setDialogStatus(false);
            AppAlert(res.msg);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

  return (
    <>
        <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(true)}>Update Progress</button>
        <Dialog
            open={dialogStatus}
            onClose={()=>setDialogStatus(false)}
            fullWidth={true}
            maxWidth="md"
            
        >
            <DialogContent>
                {formData.map((field ,i) =>
                    <div className='row mt-2' key={field.id}>
                        <div className='col-md-4'><span className='fw-bold'>{field.title}  </span></div>
                        <div className='col-md-4'>
                            <input type='number'   className='form-control' value={field.completed} onChange={(e)=>handleInputChange(i,"completed",e.target.value)}  />
                        </div>
                    </div>    
                )}
                <div className='row mt-2'>
                    <div className='col-md-12'>
                        <div className="form-floating">
                            <textarea className="form-control" placeholder="remark" value={remark} onChange={(e)=>setRemark(e.target.value)} ></textarea>
                            <label >Remark</label>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                {saving ?
                    <div className=''><CircularProgress/></div>
                    :
                    <button className='btn btn-outline-primary' onClick={handleSubmit}>Submit</button>
                }
                
            </DialogActions>
            
        </Dialog>
    </>
  )
}

export default DPRForm